<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('命令类型')">
              <a-select  v-model="queryParam.cmd">
                <a-select-option value="0">{{ $t('终端参数设置') }}</a-select-option>
                <a-select-option value="1">{{ $t('查询终端参数') }}</a-select-option>
                <a-select-option value="2">{{ $t('查询基础信息') }}</a-select-option>
                <a-select-option value="3">{{ $t('历史日结信息查询') }}</a-select-option>
                <a-select-option value="4">{{ $t('阀门动作记录查询') }}</a-select-option>
                <a-select-option value="5">{{ $t('联网失败记录') }}</a-select-option>
                <a-select-option value="6">{{ $t('终端故障记录') }}</a-select-option>
                <a-select-option value="7">{{ $t('开阀') }}</a-select-option>
                <a-select-option value="8">{{ $t('关阀') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表类型')">
              <a-input :placeholder="$t('请输入表类型')" v-model="queryParam.meterType"></a-input>
            </a-form-item>
          </a-col>
        <template v-if="toggleSearchStatus">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('模组号 ')">
              <a-input :placeholder="$t('请输入15位模组号 ')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{x: true}"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <!-- 表单区域 -->
    <partCommand-modal ref="modalForm" @ok="modalFormOk"></partCommand-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import {isUndefined} from'@/utils/validate'
  import PartCommandModal from './modules/PartCommandModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import configService from '@/utils/service/config.service'
  import {dataFlagObj,reportStatusObj} from '@/utils/constants/protocolConstant'

  export default {
    name: "PartCommandList",
    mixins:[JeecgListMixin],
    components: {
      PartCommandModal
    },
    data () {
      return {
        description: '命令管理管理页面',
	url: {
          list: "/jeecg-charge/model/partCommand/list",
          delete: "/jeecg-charge/model/partCommand/delete",
          deleteBatch: "/jeecg-charge/model/partCommand/deleteBatch",
          exportXlsUrl: "jeecg-charge/model/partCommand/exportXls",
          importExcelUrl: "jeecg-charge/model/partCommand/importExcel",
      },
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${configService.apiUrl}/${this.url.importExcelUrl}`;
    },
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:(t,r,index) => {
            return parseInt(index)+1;
          }
        },{
          title: this.$t('命令类型'),
          align:"center",
          dataIndex: 'cmd',
          customRender:(text) => {
            let data = dataFlagObj
            return this.$t(data[text])
          }
        },{
          title: this.$t('表类型'),
          align:"center",
          dataIndex: 'meterType'
        },{
          title: this.$t('模组号 '),
          align:"center",
          dataIndex: 'meterId'
        },{
          title: this.$t('发送状态'),
          align:"center",
          dataIndex: 'status',
          customRender:(t,r,index) => {
            let data = reportStatusObj
            if(isUndefined(data[t])) {
              return this.$t("其他")
            }
            return this.$t(data[t])
          }
        },{
          title: this.$t('发送时间'),
          align:"center",
          dataIndex: 'sendTime'
        },{
          title: this.$t('接收回应时间'),
          align:"center",
          dataIndex: 'receiveTime'
        },{
          title: this.$t('指令标记帧'),
          align:"center",
          dataIndex: 'mid'
        },{
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          flex: "right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        }
      ]
    },
  },
  methods: {
  },
}
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>